/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnknownStatePaymentDto } from './UnknownStatePaymentDto';
import {
    UnknownStatePaymentDtoFromJSON,
    UnknownStatePaymentDtoFromJSONTyped,
    UnknownStatePaymentDtoToJSON,
    UnknownStatePaymentDtoToJSONTyped,
} from './UnknownStatePaymentDto';
import type { FailedPspNotificationDto } from './FailedPspNotificationDto';
import {
    FailedPspNotificationDtoFromJSON,
    FailedPspNotificationDtoFromJSONTyped,
    FailedPspNotificationDtoToJSON,
    FailedPspNotificationDtoToJSONTyped,
} from './FailedPspNotificationDto';
import type { NonCapturedPaymentDto } from './NonCapturedPaymentDto';
import {
    NonCapturedPaymentDtoFromJSON,
    NonCapturedPaymentDtoFromJSONTyped,
    NonCapturedPaymentDtoToJSON,
    NonCapturedPaymentDtoToJSONTyped,
} from './NonCapturedPaymentDto';

/**
 * 
 * @export
 * @interface PaymentOperationsDto
 */
export interface PaymentOperationsDto {
    /**
     * 
     * @type {Array<UnknownStatePaymentDto>}
     * @memberof PaymentOperationsDto
     */
    unknownStatePayments: Array<UnknownStatePaymentDto>;
    /**
     * 
     * @type {Array<FailedPspNotificationDto>}
     * @memberof PaymentOperationsDto
     */
    failedPspNotifications: Array<FailedPspNotificationDto>;
    /**
     * 
     * @type {Array<NonCapturedPaymentDto>}
     * @memberof PaymentOperationsDto
     */
    nonCapturedPayments: Array<NonCapturedPaymentDto>;
}

/**
 * Check if a given object implements the PaymentOperationsDto interface.
 */
export function instanceOfPaymentOperationsDto(value: object): value is PaymentOperationsDto {
    if (!('unknownStatePayments' in value) || value['unknownStatePayments'] === undefined) return false;
    if (!('failedPspNotifications' in value) || value['failedPspNotifications'] === undefined) return false;
    if (!('nonCapturedPayments' in value) || value['nonCapturedPayments'] === undefined) return false;
    return true;
}

export function PaymentOperationsDtoFromJSON(json: any): PaymentOperationsDto {
    return PaymentOperationsDtoFromJSONTyped(json, false);
}

export function PaymentOperationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentOperationsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'unknownStatePayments': ((json['unknownStatePayments'] as Array<any>).map(UnknownStatePaymentDtoFromJSON)),
        'failedPspNotifications': ((json['failedPspNotifications'] as Array<any>).map(FailedPspNotificationDtoFromJSON)),
        'nonCapturedPayments': ((json['nonCapturedPayments'] as Array<any>).map(NonCapturedPaymentDtoFromJSON)),
    };
}

export function PaymentOperationsDtoToJSON(json: any): PaymentOperationsDto {
    return PaymentOperationsDtoToJSONTyped(json, false);
}

export function PaymentOperationsDtoToJSONTyped(value?: PaymentOperationsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unknownStatePayments': ((value['unknownStatePayments'] as Array<any>).map(UnknownStatePaymentDtoToJSON)),
        'failedPspNotifications': ((value['failedPspNotifications'] as Array<any>).map(FailedPspNotificationDtoToJSON)),
        'nonCapturedPayments': ((value['nonCapturedPayments'] as Array<any>).map(NonCapturedPaymentDtoToJSON)),
    };
}

